import React, { useState, useEffect, lazy } from 'react'
import { IonButton, IonContent, IonIcon, IonPage, IonToolbar, useIonViewDidEnter } from '@ionic/react'
import { caretBack } from 'ionicons/icons'
import { SafetyPadding } from '../../components/SafetyPadding'
import { goToPage } from '../../helpers/app_actions'
import { WalkI } from '../../interfaces/Walk'
import history from '../../helpers/history'
import goToWalk from '../HomePage'
const GoogleMapImage = lazy(() => import('../../components/GoogleMapImage'))
const WalkPreview = lazy(() => import('./WalkPreview'))

export const MultipleWalksPage = () => {
  const [state, setState] = useState({
    walksOnSame: [],
    mapWidth: 0,
    mapHeight: 0,
    view: false,
  })

 useIonViewDidEnter(() => {
  const location = history.location.state as any
   if(location) {
     setState({
       walksOnSame: location.walksOnSame,
       mapWidth: location.mapWidth,
       mapHeight: location.mapHeight,
       view: location.view,
     })
   }
 })

  return (
    <IonPage className="cheap_desktop">
      <IonToolbar 
        slot="fixed"
        color="light" 
        onClick={() => goToPage('/walk/home')}>
        <IonButton fill="clear">
          <IonIcon icon={caretBack} color="dark"/>
        </IonButton>
      </IonToolbar>
      <IonContent>
      { state.walksOnSame.map((walk: WalkI, key: number) => {
          const markers = [
            {
              lat: walk.lat,
              lng: walk.lng,
            }
          ]
        return <div key={'walksonsame-' + key} className="flex justify-center"><GoogleMapImage 
          markers={markers} 
          width={state.mapWidth} 
          height={250}
          classes="rounded_top"/></div>
        })[0] } 
      { state.walksOnSame.map((walk: WalkI, key: number) => walk.booked || !walk.hasCoordinates ? <div key={key}></div> : <WalkPreview 
        key={key}
        showMap={false}
        view={state.view}
        walk={walk}
        goToWalk={goToWalk}
        mapWidth={state.mapWidth}
        mapHeight={state.mapHeight}/>)}
        <SafetyPadding/>
      </IonContent>
    </IonPage>
  )
}
